import EmployeeIndexHeaderComponent from './Employee/EmployeeIndex/HeaderComponent'
import POSIndexHeaderComponent from './POS/POSIndex/HeaderComponent'
import VoucherIndexHeaderComponent from './Voucher/VoucherIndex/HeaderComponent'
import VoucherRequestHeaderComponent from './Voucher/VoucherRequest/HeaderComponent'

const MerchantHeader = () => {
  const headers = [
    {
      routes: ['merchant.employees.index'],
      component: <EmployeeIndexHeaderComponent />,
    },
    {
      routes: ['merchant.vouchers.index'],
      component: <VoucherIndexHeaderComponent />,
    },
    {
      routes: ['merchant.vouchers.request'],
      component: <VoucherRequestHeaderComponent />,
    },
    {
      routes: ['merchant.pos.index'],
      component: <POSIndexHeaderComponent />,
    },
  ]

  const header = headers.find(({ routes }) => routes.some((r) => r === route().current()))

  return header?.component ?? null
}

export default MerchantHeader
